import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Form, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap'
import Api from '../../../../Global/Modules/Api'

const FETCH_URL = "api/auth/user/"

class ChangePasswordAdmin extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            data: {
                id: this.props.match.params.id,
                password: "",
            },
            member: {
            },
            header: {
            },
            rePassword: "",
            errors: {}
        }
    }


    componentDidMount() {
        var url = "api/members/" + this.props.match.params.id;
        Api.GetApi(url).then(data => {
            this.setState({ member: data })
            this.setState({ header: data.header })
        });
    }

    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        Api.print("Data to send")
        Api.print(this.state.data)
        Api.print("---------------")
        this.setState({ errors: {} });
        if (this.state.data.password !== this.state.rePassword)
            this.setState({ errors: { password: 'Passwords do not match' } })

        else {
            Api.PostApi("api/members/" + this.props.match.params.id + "/password/", this.state.data, this.props.history)
                .then(response => {
                    Api.print("Response")
                    Api.print(response)
                    Api.print(("---------------"))
                    if (response !== undefined) {
                        this.setState({ errors: response });
                    }
                    else {
                        alert("User updated")
                        window.location.href = "/admin/leden/lid/gegevens/" + this.props.match.params.id
                        // TODO: Show message OK, redirect to the previous page or something like this
                    }
                })
        }
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value

        if (name === "roleId") this.setState({ data: { ...this.state.data, [name]: parseInt(value) } })
        else name === "rePassword" ? this.setState({ [name]: value }) : this.setState({ data: { ...this.state.data, [name]: value } })

    }

    render() {
        let data = this.state.data
        let rePassword = this.state.rePassword
        let errors = this.state.errors
        return (
            <div>
                <Row>
                    <Form horizontal onSubmit={this.handleSubmit}>
                        <Col md={12}>
                            <FormGroup controlId="AccountTitel">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Naam
                            </Col>
                                <Col sm={6}>
                                    {this.state.header.name}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="AccountPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Wachtwoord
                            </Col>
                                <Col sm={6}>
                                    {/**<FormControl type="password" placeholder="" defaultValue="xxxxxxx"/>**/}
                                    <FormControl type="password" name="password" value={data.password} onChange={this.handleChange} />
                                    {Api.showError(errors, "password")}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="AccountPasswordCheck">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Wachtwoord  controle
                            </Col>
                                <Col sm={6}>
                                    {/**<FormControl type="password" placeholder=""  defaultValue="xxxxxxx"/>**/}
                                    <FormControl type="password" name="rePassword" value={rePassword} onChange={this.handleChange} />
                                    {Api.showError(errors, "password")}
                                </Col>
                            </FormGroup>

                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Col sm={12}>
                                    <LinkContainer to={"/admin/leden/lid/gegevens/" + this.props.match.params.id}><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                                    <Button type="submit" className="pull-right">Wijzigen</Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Form>
                </Row>
            </div>
        );
    }
}

export default ChangePasswordAdmin;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/WachtwoordWijzigen.js